import React from 'react'
import { GetRoadHome } from "../components/newHome/GetRoadHome";
import refresher from "../assets/images/refresher-lessons.png";
import Knowledge from '../components/knowledge/Knowledge';
const RefreshersCourses = () => {
  return (
    <>
     <GetRoadHome
        heading="Refresher Lessons
"
        image={refresher}
      />
      <Knowledge/>
    </>
  )
}

export default RefreshersCourses